module.exports = __webpack_public_path__ + "static/img/8areaB_07.fa96528.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_07.png
// module id = 1227
// module chunks = 1